import React from 'react';
import PropTypes from 'prop-types';
import ListViewDocument from './ListViewDocument';
function DocumentsListView(_ref) {
  var documents = _ref.documents;
  return /*#__PURE__*/React.createElement("div", {
    className: "documents-list-view detail-info__relationship"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "detail-info__relationship-files list-unstyled"
  }, documents.map(function (doc, i) {
    return /*#__PURE__*/React.createElement(ListViewDocument, {
      id: "document-".concat(i),
      key: i,
      doc: doc
    });
  })));
}
DocumentsListView.propTypes = {
  documents: PropTypes.array
};
DocumentsListView.defaultProps = {
  documents: []
};
export default DocumentsListView;
//# sourceMappingURL=DocumentsListView.js.map